/**
 * Shared list query filter/sort types used by both backend and frontend.
 * This is the single source of truth — imported by @zag/core/api (backend)
 * and @zag/ui resource layer (frontend).
 */

export type ListSortDirection = 'asc' | 'desc';

export type ListFilterOperator =
  | 'eq'
  | 'ne'
  | 'in'
  | 'nin'
  | 'contains'
  | 'startsWith'
  | 'endsWith'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'isNull'
  | 'isNotNull';
